import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Link as ScrollTo } from "react-scroll";
import { useSelector } from "react-redux";
import { FaRegTimesCircle } from "react-icons/fa";
import headerStyles from "./DesktopHeader.module.css";
import { AddFeedback } from "../../../Redux/Actions";
import {
  SearchBar,
  CitySelect,
  Cart,
  Profile,
  UploadPrescription,
  CallUs,
  Pathology,
} from "./DesktopHeaderComponents";

const DesktopHeader = () => {
  const history = useHistory();
  let location = useLocation();

  const feedbackSent = useSelector(
    (state) => state.AddFeedbackReducer.feedbackSent
  );

  const [activeTab, setActiveTab] = useState(NaN);
  const [show, setShow] = useState(false);
  const [successdiv, setSuccssDiv] = useState(false);
  const [feedbackPhoneError, setFeedbackPhoneError] = useState("");
  const [feebackError, setFeedbackError] = useState("");
  const [feedbackPhone, setFeedbackPhone] = useState("");
  const [disable, setDisable] = useState(false);
  const citySelect = useSelector((state) => state.cityOnTopNav.citySelect);
  var isFeedBackNumber = null;
  // console.log(citySelect,"citySelect")
  const bottomBarNavTabs = [
    // {
    //   name: "About",
    //   // href: "https://redcliffelabs.com/about-us",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/about-us`,
    //   ext: true,
    // },
    {
      name: "Imaging Tests",
      href: `/imaging/health-checkup-packages${
        citySelect ? "-" + citySelect.toLowerCase() : ""
      }`,
      ext: false,
    },
    {
      name: "Pathology",
      href: "/",
      ext: true,
    },
    // {
    //   name: "Our Labs & Network",
    //   // href: "https://redcliffelabs.com/lab-centre-network",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/lab-centre-network`,
    //   ext: true,
    // },
    // {
    //   name: "Blogs",
    //   // href: "https://redcliffelabs.com/blog",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/blog`,
    //   ext: true,
    // },
    // {
    //   name: "Gift Card",
    //   // href: "https://redcliffelabs.com/gift-card",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/gift-card`,
    //   ext: true,
    // },
    {
      name: "Contact Us",
      // href: "https://redcliffelabs.com/contact-us",
      href: `/imaging/contact`,
      ext: false,
    },
  ];

  const [feedbackMsg, setFeedback] = useState("");

  useEffect(() => {
    let pathname = history.location.pathname;
    let len = bottomBarNavTabs.length;
    for (let i = 0; i < len; i++) {
      if (pathname.includes("/imaging/health-checkup-packages")) {
        setActiveTab(0);
        break;
      }
      if (pathname === bottomBarNavTabs[i].href) {
        setActiveTab(i);
        break;
      }
    }
  }, []);

  useEffect(() => {
    if (
      feedbackPhone == "" ||
      feedbackMsg == "" ||
      feebackError !== "" ||
      feedbackPhoneError !== ""
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [feedbackPhone, feedbackMsg, feebackError, feedbackPhoneError]);

  const handelClose = () => {
    setShow(!show);
    setSuccssDiv(false);
  };

  const handelPhone = (e) => {
    setFeedbackPhone(e.target.value);
    setFeedbackPhoneError("");
  };

  const handelFeedback = (e) => {
    setFeedback(e.target.value);
    const characterRegex = /^([A-Za-z0-9]+[ ]?)+$/;
    setFeedbackError("");
    if (!e.target.value.match(characterRegex)) {
      setFeedbackError("Invalid feedback");
    }
    if (e.target.value == "") {
      setFeedbackError("");
    }
  };

  const validateContantInfo = (val) => {
    let phoneno = /^\d{10}$/;
    let regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (val.match(phoneno) && parseInt(val[0]) >= 6) {
      isFeedBackNumber = true;
      return true;
    } else if (regex.test(val)) {
      isFeedBackNumber = false;
      return true;
    } else {
      if (isNaN(val)) {
        setFeedbackPhoneError("Enter valid details");
      } else {
        setFeedbackPhoneError("Enter valid details");
      }
      return false;
    }
  };

  const sendFeedback = (e) => {
    e.preventDefault();
    if (validateContantInfo(feedbackPhone)) {
      var body = {};
      if (isFeedBackNumber) {
        body = {
          content: feedbackMsg,
          mobile: feedbackPhone,
        };
      } else {
        body = {
          content: feedbackMsg,
          email: feedbackPhone,
        };
      }

      AddFeedback(body);
      setSuccssDiv(true);
      setFeedback("");
      setFeedbackPhone("");
      setFeedbackPhoneError("");
    }
  };

 
  return (
    <div className={headerStyles.header_container}>
      {/* DESKTOP HEADER TOP BAR */}
      <div className={headerStyles.header_top_container}>
        <div className={headerStyles.header_top}>
          <div className={headerStyles.logoDiv}>
            {/* <Link href="/imaging"> */}
            <Link to={"/imaging"}>
              <img
                // src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg"
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e297bdda-8a10-4cf2-b567-c0d2d911e32c.webp"
                width="128"
                height="39"
                // className={headerStyles.img_pos}
                // layout="intrinsic"
                // placeholder="blur"
              />
            </Link>
            {/* </Link> */}
          </div>
          <div className={headerStyles.mid_section}>
            <div className={headerStyles.cityAndSearch}>
              <CitySelect />
              <div
                style={{ borderRight: "2px solid #2E2E2E", height: "1.5rem" }}
              />
              <SearchBar />
            </div>
            {/* {location.pathname.split("/")[1] !== "imaging" && <Cart />} */}

            <Profile />
          </div>
          {/* <div className={headerStyles.uploadPresPos}>
            {location.pathname.split("/")[1] !== "imaging" && (
              <UploadPrescription />
            )}
          </div> */}
          <div className={headerStyles.verticalLine} />
          <CallUs />
        </div>
      </div>
      {/* END DESKTOP HEADER TOP BAR */}

      {/* DESKTOP HEADER BOTTOM BAR */}
      <div className={headerStyles.header_bottom_container}>
        <div className={headerStyles.header_bottom}>
          <div className={headerStyles.navTabsContainer}>
            {bottomBarNavTabs.map((tab, index) => {
              if (index === 1) {
                return (
                  <div key={index}>
                    <Pathology />
                  </div>
                );
              }
              if (tab.ext === false) {
                return (
                  <Link to={tab.href} key={index}>
                    <div
                      className={`${headerStyles.navTab}
                        ${activeTab === index ? headerStyles.navTabActive : ""}
                      `}
                      onClick={() => setActiveTab(index)}
                    >
                      <span
                        className={`${headerStyles.navTabText}
                          ${
                            activeTab === index
                              ? headerStyles.navTabTextActive
                              : ""
                          }
                        `}
                      >
                        {tab.name}
                      </span>
                    </div>
                  </Link>
                );
              } else {
                return (
                  <a href={tab.href} key={index}>
                    <div className={`${headerStyles.navTab}`}>
                      <span className={`${headerStyles.navTabText}`}>
                        {tab.name}
                      </span>
                    </div>
                  </a>
                );
              }
            })}

            {/* FAQs */}
            {history.location.pathname === "/imaging" && (
              <ScrollTo
                className={headerStyles.navTab}
                to="faq"
                // offset={-110}
                smooth={true}
                duration={500}
              >
                <span className={headerStyles.navTabText}>FAQs</span>
              </ScrollTo>
            )}
          </div>
        </div>
      </div>

      <div
        className={
          show
            ? "feedback feedbackNew  onScreen onScreenNew"
            : "feedback feedbackNew  offScreen"
        }
      >
        <div className="feedbackContent">
          <div className="feedbackForm feedbackFormNew">
            <form onSubmit={sendFeedback}>
              {feedbackSent && successdiv ? (
                <div className="feedbackSent">
                  <p>Your feedback has been successfully sent</p>
                  <button
                    className="submit_primary submit_light  "
                    onClick={handelClose}
                  >
                    Close
                  </button>
                </div>
              ) : null}
              <p>
                Tell us about your query or how we can make our services better
              </p>
              <input
                className="feedBackPhone"
                required
                value={feedbackPhone}
                placeholder="Enter Phone Number/Email ID"
                type="text"
                onChange={handelPhone}
              />
              {feedbackPhoneError != "" ? (
                <span className="feedbackPhoneError">{feedbackPhoneError}</span>
              ) : null}
              <textarea
                placeholder="Write something"
                value={feedbackMsg}
                required
                onChange={handelFeedback}
              />
              <span className="error">{feebackError}</span>
              <div className="feedbackButton  ">
                <button
                  disabled={disable ? "disabled" : ""}
                  className={
                    disable
                      ? "disable submit_primary hoverGreen"
                      : "submit_primary hoverGreen"
                  }
                >
                  Submit
                </button>
                <span
                  style={{ cursor: "pointer" }}
                  className="submit_primary submit_light  "
                  onClick={() => {
                    setShow(!show);
                    setFeedback("");
                    setFeedbackPhone("");
                    setFeedbackPhoneError("");
                  }}
                >
                  Cancel
                </span>
              </div>
            </form>
          </div>
          <span className="pinkFeedbackNew" onClick={handelClose}>
            Feedback&nbsp;
            {show ? <FaRegTimesCircle onClick={handelClose} /> : null}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeader;
